function Testimonial(props){

    const imageName = props.name.toLowerCase().replaceAll(" ","-");

    return (
        <div className="testimonial">
            <div className="testimonial-header">
                <div className="testimonial-image">
                    <img src={`../images/testimonial-${imageName}.png`} alt="testimonial" />
                </div>
                <div className="testimonial-info">
                    <div className="testimonial-name">{props.name}</div>
                    <div className="testimonial-title font-s">{props.title}</div>
                </div>
            </div>
            <p className="testimonail-body">{props.children}</p>
            {(props.weblink || props.linkedin) && <p className="testimonial-links">
                {props.weblink && <a href={props.weblink} className="testimonial-link web" target="_blank" rel="noreferrer">&nbsp;</a>}
                {props.linkedin && <a href={props.linkedin} className="testimonial-link linkedin" target="_blank" rel="noreferrer">&nbsp;</a>}
            </p>}
            {props.drop}
        </div>
    );
    
}

export default Testimonial;